import React from 'react';
import { Box, IconButton } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import ClearIcon from '@mui/icons-material/Clear';
import dayjs from 'dayjs';
import { useTranslatedMessages } from '../../hooks/useTranslatedMessages';
import { getDatePickerProviderProps } from '../../utils/datePickerLocale';

const toDayjs = (value) => (value ? dayjs(value) : null);

const DateRangeFilter = ({ value, onChange }) => {
  const documentDate = value?.document_date ?? {};
  const startDate = toDayjs(documentDate.start);
  const endDate = toDayjs(documentDate.end);
  const { language, documentReports } = useTranslatedMessages();
  const datePickerLocale = getDatePickerProviderProps(language);
  const startDateLabel = documentReports?.document_report?.start_date ?? 'Start Date';
  const endDateLabel = documentReports?.document_report?.end_date ?? 'End Date';

  const emitChange = (start, end) => {
    onChange({
      document_date: {
        start: start ? dayjs(start).format('YYYY-MM-DD') : null,
        end: end ? dayjs(end).format('YYYY-MM-DD') : null,
      },
    });
  };

  const handleStartDateChange = (date) => {
    emitChange(date, endDate);
  };

  const handleEndDateChange = (date) => {
    emitChange(startDate, date);
  };

  const handleClearStartDate = () => {
    emitChange(null, endDate);
  };

  const handleClearEndDate = () => {
    emitChange(startDate, null);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} {...datePickerLocale}>
      <Box display="flex" gap={1}>
        <Box position="relative">
          <DatePicker
            label={startDateLabel}
            format="DD/MM/YYYY"
            value={startDate}
            onChange={handleStartDateChange}
            minDate={endDate ? endDate.subtract(1, 'year') : null}
            maxDate={endDate && endDate.isBefore(dayjs()) ? endDate : dayjs()}
            slotProps={{
              textField: {
                size: 'small',
                sx: { minWidth: 150 },
              },
            }}
          />
          {startDate && (
            <IconButton
              size="small"
              sx={{
                position: 'absolute',
                right: '28px',
                top: '50%',
                transform: 'translateY(-50%)',
                zIndex: 1,
              }}
              onClick={handleClearStartDate}
            >
              <ClearIcon fontSize="small" />
            </IconButton>
          )}
        </Box>
        <Box position="relative">
          <DatePicker
            label={endDateLabel}
            format="DD/MM/YYYY"
            value={endDate}
            onChange={handleEndDateChange}
            minDate={startDate ? startDate : null}
            maxDate={startDate && startDate.add(1, 'year').isBefore(dayjs()) ? startDate.add(1, 'year') : dayjs()}
            slotProps={{
              textField: {
                size: 'small',
                sx: { minWidth: 150 },
              },
            }}
          />
          {endDate && (
            <IconButton
              size="small"
              sx={{
                position: 'absolute',
                right: '28px',
                top: '50%',
                transform: 'translateY(-50%)',
                zIndex: 1,
              }}
              onClick={handleClearEndDate}
            >
              <ClearIcon fontSize="small" />
            </IconButton>
          )}
        </Box>
      </Box>
    </LocalizationProvider>
  );
};

export default DateRangeFilter;
